import { Box } from '@mui/material';

function ProductsLayout({ children }) {
  return (
    <Box className="grow flex flex-col px-20 py-16 gap-16 bg-white overflow-hidden">
      <Box className="flex-1 overflow-auto">{children}</Box>
    </Box>
  );
}

export default ProductsLayout;
